import logoBgdl from '../../assets/media/logos/bgdl/bgdl-isotipo-color.svg';
import logoBuro from '../../assets/media/logos/buro/buro-isotipo-color.svg'
import logoEj from '../../assets/media/logos/enlace/ej-isotipo-color.svg';
export default function Sistema({sistema}){
    switch(sistema){
        case 'BGDL':
            return <i className="fs-2tx text-muted fi-bgdl"></i>
        case 'EJ':
            return <i className="fs-2tx text-muted fi-historial"></i>
        default:
            return <i className="fs-2tx text-muted fi-buro"></i>
    }
}

export function SistemaColor({sistema}){
    switch (sistema) {
        case 'BGDL':
            return <img alt="Bolet&iacute;n GDL" style={{width : '2.75rem'}} src={logoBgdl}/>
        case 'EJ':
            return <img alt="Enlace Jurí&iacute;dico" style={{width : '2.75rem'}} src={logoEj}/>
        default:
            return <img alt="Bolet&iacute;n GDL" style={{width : '2.75rem'}} src={logoBuro}/>
    }

}

export function SistemaTexto({sistema}){
    switch (sistema){
        case 'BGDL':
            return <span>Boletín GDL</span>
        case 'EJ':
            return <span>Enlace Jur&iacute;dico</span>
        default:
            return <span>Buro Judicial</span>
    }
}

export function sistemaGeneral(sistema){
    switch (sistema){
        case 'BGDL':
            return {
                logo : logoBgdl,
                nombre : "Bolet&iacute;n GDL"
            }
        case 'EJ':
            return {
                logo : logoEj,
                nombre : "Enlace Jurí&iacute;dico",
            }
        default:
            return {
                logo : logoBuro,
                nombre: "Buro"
            }
    }
}
